module.exports = __webpack_public_path__ + "img/vgt_logo.935d92bd.png";